
import {useState, ReactNode} from 'react';
import {useEventEffect} from '@esgi/events';
import {TabSelectedEvent} from './events';

interface Props {
	name: string;
	children: ReactNode;
}
export const TabPanel = (props: Props): JSX.Element => {
	const {name, children} = props;
	const [visible, setVisible] = useState(false);

	useEventEffect(TabSelectedEvent, ({tab}) => setVisible(tab?.name === name));

	return visible && (
		<>{children}</>
	);
};
